import React from "react";
import ReactLogo from "../../homeLogo.svg";
import "./About.css";

const About = () => {
    return (<React.Fragment>
        <section className="about">
            <div className="heading">
                <h1>About Us</h1>
                <img src={ReactLogo} alt="about" className="about_img" />
            </div>
            <div className="main">
                <p>I'm Shivansh Mehrotra. B.tech. graduate from JSS Academy of Technical education, Noida.
                    I have knowledge of web dev skills and currently working as ASE in TCS.</p>
                <h3>Skills</h3>
                <p>HTML, CSS, Javascript, Reactjs, Redux, C++, Git/Github</p>
            </div>
        </section>
    </React.Fragment>)
}

export default About;